// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { useTheme } from '@mui/material';

import Tile, { TileProps } from '@components/Timeline/Tile/Tile';
import TileIconHopdrive from '@components/Timeline/Tile/TileIconHopdrive';

// TYPES ---------------------------------------------------------------- //

export interface ShuttleRideProps
  extends Omit<
    TileProps,
    'color' | 'extraWidthBeforeLabel' | 'extraWidthBetweenLabel' | 'extraWidthAfterLabel' | 'secondaryIcon' | 'variant'
  > {}

// COMPONENT ---------------------------------------------------------------- //

const ShuttleRide = ({ ...props }: ShuttleRideProps) => {
  const theme = useTheme();

  return (
    <Tile
      color={theme.palette.shuttle.main}
      extraWidthBeforeLabel={`WAIT`}
      extraWidthBetweenLabel={`???`}
      extraWidthAfterLabel={`RIDE`}
      secondaryIcon={<TileIconHopdrive />}
      variant={`outlined`}
      {...props}
    />
  );
};

// EXPORT ---------------------------------------------------------------- //

export default ShuttleRide;
